module.exports = __webpack_public_path__ + "static/Enchante (5)-05e0ddc799898e18026e7eddc6f65f9c.jpeg";